import { STAGES } from '../const';
import errorImage from '../assets/images/error-state.svg';
import Stage from '../components/stages';
import '../assets/styles/form.scss';
import EmailSubmit from '../components/stages/modal';
import PendingState from '../components/loader/PendingState';
import useHandleSubmitForm from '../hooks/useHandleSubmitForm';

const ErrorMessage = ({ errorMessage, setSending }) => {
  const onCloseMessage = () => {
    setSending(false);
  };

  return (
    <div className="laForm__errorMessage__body">
      <div>
        <div>
          <img src={errorImage} width="308" height="216" alt="Error state" />
          <p>{errorMessage}</p>
          <button
            type="button"
            className="primaryFatLink"
            onClick={onCloseMessage}
            id="btn-try-again--popup"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  );
};

const Form = () => {
  const {
    isError,
    errorMessage,
    register,
    handleSubmit,
    watch,
    resetField,
    reset,
    getValues,
    onSubmit,
    pageContainerRef,
    isSent,
    setSending,
    activeStep,
    setStep,
    projectType,
    setProjectType,
    projectDomain,
    setProjectDomain,
    uploadedFile,
    setUploadedFile,
    formStateErrors,
  } = useHandleSubmitForm();

  return (
    <main className="laForm" ref={pageContainerRef}>
      <h1 className="hidden-title">Surveys</h1>
      {activeStep != STAGES.length && (
        <div className="laForm__stage-progress">
          <ul>
            {STAGES.map((item) => (
              <li
                key={item.id}
                className={`laForm__stage${
                  item.id === activeStep
                    ? ' active current'
                    : item.id <= activeStep
                      ? ' active'
                      : ''
                } `}
              >
                <span className="laForm__stage-mobile-info">
                  {item.mobile_name}
                </span>
                <span className="laForm__stage-desktop-info">
                  {item.id}. {item.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="laForm__stage-content">
          {STAGES.map((item) => (
            <Stage
              key={item.id}
              currentStep={item}
              activeStep={activeStep}
              setStep={setStep}
              register={register}
              watch={watch}
              projectType={projectType}
              setProjectType={setProjectType}
              projectDomain={projectDomain}
              setProjectDomain={setProjectDomain}
              resetField={resetField}
              reset={reset}
              getValues={getValues}
              uploadedFile={uploadedFile}
              setUploadedFile={setUploadedFile}
              formStateErrors={formStateErrors}
              isSent={isSent}
              setSending={setSending}
              isError={isError}
              errorMessage={errorMessage}
            />
          ))}
        </div>
      </form>
    </main>
  );
};

export default Form;
